import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, Transition as _Transition, Fragment as _Fragment } from "vue"
import _imports_0 from './assets/eclipseds.png'


const _hoisted_1 = {
  id: "closed-top-container",
  class: "budge"
}
const _hoisted_2 = {
  id: "title-row",
  class: "non-map-row"
}
const _hoisted_3 = { id: "title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  id: "instructions-row",
  class: "non-map-row"
}
const _hoisted_8 = { id: "top-container-main-text" }
const _hoisted_9 = {
  key: 0,
  class: "instructions-text"
}
const _hoisted_10 = { class: "description" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = {
  key: 1,
  class: "instructions-text"
}
const _hoisted_16 = { class: "description" }
const _hoisted_17 = { class: ".d-flex" }
const _hoisted_18 = {
  id: "button-row",
  class: "non-map-row"
}
const _hoisted_19 = { id: "top-container-buttons" }
const _hoisted_20 = { id: "map-column" }
const _hoisted_21 = {
  class: /*@__PURE__*/_normalizeClass(['']),
  id: "map-container"
}
const _hoisted_22 = { class: "map-bottomleft-stack" }
const _hoisted_23 = {
  key: 0,
  id: "location-status-box-overmap"
}
const _hoisted_24 = { class: "location-status-name" }
const _hoisted_25 = {
  key: 0,
  class: "eclipse-status-line"
}
const _hoisted_26 = {
  key: 1,
  class: "map-topright-stack"
}
const _hoisted_27 = { style: {"min-height":"120px"} }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "text-list" }
const _hoisted_31 = { class: "text-list" }
const _hoisted_32 = { class: "ml-5" }
const _hoisted_33 = { class: "text-list" }
const _hoisted_34 = { class: "text-list" }
const _hoisted_35 = { id: "main-content" }
const _hoisted_36 = {
  key: 0,
  id: "center-page-banner"
}
const _hoisted_37 = { id: "location-date-display" }
const _hoisted_38 = { class: "location-status-name" }
const _hoisted_39 = {
  key: 0,
  class: "eclipse-status-line"
}
const _hoisted_40 = { id: "location-secondary-row" }
const _hoisted_41 = { id: "first-splash-row" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 0,
  class: "splash-small-text"
}
const _hoisted_44 = {
  class: "modal",
  id: "modal-loading"
}
const _hoisted_45 = { class: "instruction-overlay instruction-overlay-mobile elevation-10" }
const _hoisted_46 = { class: "inst-quad top-left" }
const _hoisted_47 = { class: "inst-arrow" }
const _hoisted_48 = { class: "inst-quad top-right" }
const _hoisted_49 = { class: "inst-arrow" }
const _hoisted_50 = { class: "inst-quad bottom-left" }
const _hoisted_51 = { class: "inst-arrow" }
const _hoisted_52 = { class: "inst-text" }
const _hoisted_53 = { class: "intro-bottom-controls" }
const _hoisted_54 = { class: "instruction-overlay instruction-overlay-desktop elevation-10" }
const _hoisted_55 = { class: "inst-quad top-left" }
const _hoisted_56 = { class: "inst-arrow" }
const _hoisted_57 = { class: "inst-quad top-center" }
const _hoisted_58 = { class: "inst-arrow" }
const _hoisted_59 = { class: "inst-quad top-right" }
const _hoisted_60 = { class: "inst-arrow" }
const _hoisted_61 = { class: "intro-bottom-controls" }
const _hoisted_62 = { class: "inst-quad bottom-left" }
const _hoisted_63 = { class: "inst-arrow" }
const _hoisted_64 = { class: "inst-text" }
const _hoisted_65 = {
  key: 0,
  id: "introduction-overlay",
  class: "elevation-10"
}
const _hoisted_66 = { class: "intro-bottom-controls" }
const _hoisted_67 = { id: "top-right-buttons" }
const _hoisted_68 = {
  id: "controls",
  class: "control-icon-wrapper"
}
const _hoisted_69 = {
  key: 0,
  id: "control-checkboxes"
}
const _hoisted_70 = { class: "bottom-content" }
const _hoisted_71 = { id: "eclipse-percent-chip" }
const _hoisted_72 = { id: "tools" }
const _hoisted_73 = { class: "tool-container" }
const _hoisted_74 = { style: {"position":"relative"} }
const _hoisted_75 = { id: "speed-control" }
const _hoisted_76 = {
  key: 2,
  id: "inline-speed-control"
}
const _hoisted_77 = { id: "speed-text" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { id: "slider" }
const _hoisted_81 = { id: "change-optout" }
const _hoisted_82 = {
  key: 1,
  id: "body-logos"
}
const _hoisted_83 = { id: "user-experience-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_define_term = _resolveComponent("define-term")!
  const _component_cloud_cover = _resolveComponent("cloud-cover")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_location_search = _resolveComponent("location-search")!
  const _component_location_selector = _resolveComponent("location-selector")!
  const _component_v_slide_y_transition = _resolveComponent("v-slide-y-transition")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_gif_play_pause = _resolveComponent("gif-play-pause")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_funding_acknowledgment = _resolveComponent("funding-acknowledgment")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_geolocation_button = _resolveComponent("geolocation-button")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_open_meteo_forecast = _resolveComponent("open-meteo-forecast")!
  const _component_eclipse_timer = _resolveComponent("eclipse-timer")!
  const _component_playback_control = _resolveComponent("playback-control")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_credit_logos = _resolveComponent("credit-logos")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_notifications = _resolveComponent("notifications")!
  const _component_user_experience = _resolveComponent("user-experience")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_cds_privacy_policy = _resolveComponent("cds-privacy-policy")!
  const _component_v_app = _resolveComponent("v-app")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(_ctx.cssVars),
    inert: _ctx.showSplashScreen
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(_component_icon_button, {
          modelValue: _ctx.showGuidedContent,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showGuidedContent) = $event)),
          id: "show-guided-content",
          ref: "showGuidedContent",
          "fa-icon": "chevron-down",
          "fa-size": "lg",
          color: _ctx.accentColor,
          "focus-color": _ctx.accentColor,
          "tooltip-text": "Click to learn more",
          "tooltip-location": 'bottom',
          "show-tooltip": !_ctx.mobile,
          "box-shadow": false,
          onActivate: _ctx.onResize
        }, {
          button: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "chevron-down",
              size: "lg",
              class: "bullet-icon"
            }),
            _cache[91] || (_cache[91] = _createTextVNode(" Path & Weather ", -1))
          ]),
          _: 1
        }, 8, ["modelValue", "color", "focus-color", "show-tooltip", "onActivate"])
      ], 512), [
        [_vShow, !_ctx.narrow && !_ctx.showGuidedContent]
      ]),
      _createElementVNode("div", {
        id: "guided-content-wrapper",
        class: _normalizeClass({ 'mobile-fullscreen': _ctx.narrow && _ctx.showGuidedContent })
      }, [
        _withDirectives(_createVNode(_component_v_container, {
          id: "guided-content-container",
          style: _normalizeStyle(_ctx.topContainerStyle),
          class: _normalizeClass({ 'no-height-transition': _ctx.isResizingTopContainer })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              id: "non-map-container",
              style: _normalizeStyle(_ctx.nonMapContainerStyle)
            }, [
              _createElementVNode("div", _hoisted_2, [
                (!_ctx.narrow)
                  ? (_openBlock(), _createBlock(_component_icon_button, {
                      key: 0,
                      modelValue: _ctx.showGuidedContent,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showGuidedContent) = $event)),
                      id: "hide-guided-content",
                      "fa-icon": "chevron-up",
                      "fa-size": "lg",
                      color: _ctx.accentColor,
                      "focus-color": _ctx.skyColor,
                      "background-color": "transparent",
                      "tooltip-text": "Hide Info and Map",
                      "tooltip-location": 'bottom',
                      "show-tooltip": !_ctx.mobile,
                      "box-shadow": false,
                      onActivate: _ctx.onResize
                    }, null, 8, ["modelValue", "color", "focus-color", "show-tooltip", "onActivate"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.learnerPath=='Location')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Who Sees Totality? "))
                    : _createCommentVNode("", true),
                  (_ctx.learnerPath=='Clouds')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Historical Cloud Data "))
                    : _createCommentVNode("", true),
                  (!_ctx.showNewMobileUI && _ctx.learnerPath=='CloudDetail')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Explore Detailed Cloud Data "))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.narrow)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "dialog-close-button title-row-close-button",
                      onClick: _cache[2] || (_cache[2] = () => { _ctx.showGuidedContent = false; _ctx.onResize(); }),
                      onKeyup: _cache[3] || (_cache[3] = _withKeys(() => { _ctx.showGuidedContent = false; _ctx.onResize(); }, ["enter"])),
                      tabindex: "0"
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "xmark",
                        size: "xl",
                        color: _ctx.accentColor2
                      }, null, 8, ["color"])
                    ], 32))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.learnerPath=='Location')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, [
                          _cache[95] || (_cache[95] = _createElementVNode("p", null, "The path of totality is displayed across the map as a gray band with a red center line.", -1)),
                          (_ctx.narrow)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Close this view to \"watch\" the eclipse from the location marked by the red dot on the map. "))
                            : (_openBlock(), _createElementBlock("p", _hoisted_12, " \"Watch\" the eclipse from the location marked by the red dot on the map. ")),
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "Tap" : "Click"), 1),
                            _cache[92] || (_cache[92] = _createTextVNode(" the map to select any location and view the eclipse from there, or ", -1))
                          ]),
                          (_ctx.narrow)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_13, [...(_cache[93] || (_cache[93] = [
                                _createElementVNode("strong", null, "Enter a location", -1),
                                _createTextVNode(" in the search box below. ", -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_14, [...(_cache[94] || (_cache[94] = [
                                _createElementVNode("strong", null, "Enter a location", -1),
                                _createTextVNode(" in the search box to the right. ", -1)
                              ]))]))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.learnerPath=='Clouds')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", null, [
                              _cache[96] || (_cache[96] = _createTextVNode(" This map shows historical cloud cover data for the week of August 12 for the years 2003–2023 from ", -1)),
                              _cache[97] || (_cache[97] = _createElementVNode("a", {
                                href: "https://modis.gsfc.nasa.gov/",
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }, "MODIS", -1)),
                              _createTextVNode(" on NASA's Aqua satellite. " + _toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " the map to display the ", 1),
                              _createVNode(_component_define_term, {
                                term: "median",
                                definition: "For <strong>half</strong> of the years from 2003–2023 on August 12, the cloud cover amount was <strong>less</strong> than the median value. For the other <strong>half</strong> of the years, the cloud cover was <strong>more</strong> than the median value."
                              }),
                              _cache[98] || (_cache[98] = _createTextVNode(" cloud coverage for a particular location (within about 100 km). ", -1))
                            ]),
                            _createElementVNode("div", null, [
                              _createVNode(_component_cloud_cover, {
                                "cloud-cover": _ctx.selectedLocationCloudCover,
                                onCloudIcon: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cloudIcon = $event))
                              }, null, 8, ["cloud-cover"])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_icon_button, {
                    "model-value": _ctx.learnerPath == 'Location',
                    "md-icon": "map-search",
                    "md-size": "24",
                    color: _ctx.accentColor,
                    "focus-color": _ctx.accentColor,
                    "tooltip-text": 'Choose any viewing location',
                    "tooltip-location": 'bottom',
                    "show-tooltip": !_ctx.mobile,
                    "box-shadow": false,
                    onActivate: _cache[5] || (_cache[5] = () => { _ctx.learnerPath = 'Location'})
                  }, null, 8, ["model-value", "color", "focus-color", "show-tooltip"]),
                  _createVNode(_component_icon_button, {
                    "model-value": _ctx.learnerPath == 'Clouds',
                    "fa-icon": "cloud-sun",
                    "fa-size": "xl",
                    color: _ctx.accentColor,
                    "focus-color": _ctx.accentColor,
                    "tooltip-text": 'View historical cloud coverage',
                    "tooltip-location": 'bottom',
                    "show-tooltip": !_ctx.mobile,
                    "box-shadow": false,
                    onActivate: _cache[6] || (_cache[6] = () => { _ctx.learnerPath = 'Clouds'})
                  }, null, 8, ["model-value", "color", "focus-color", "show-tooltip"])
                ])
              ])
            ], 4),
            (_ctx.smAndUp)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  id: "map-column-resize-handle",
                  role: "separator",
                  "aria-orientation": "vertical",
                  "aria-label": "Resize map width",
                  tabindex: "0",
                  onMousedown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.startMapWidthResize && _ctx.startMapWidthResize(...args))),
                  onTouchstart: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.startMapWidthResize && _ctx.startMapWidthResize(...args))),
                  onKeydown: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onMapWidthResizeKeydown && _ctx.onMapWidthResizeKeydown(...args)))
                }, null, 32))
              : _createCommentVNode("", true),
            (!_ctx.smAndUp)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  id: "mobile-map-height-resize-handle",
                  role: "separator",
                  "aria-orientation": "horizontal",
                  "aria-label": "Resize map height",
                  tabindex: "0",
                  onMousedown: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.startMobileNonMapHeightResize && _ctx.startMobileNonMapHeightResize(...args))),
                  onTouchstart: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.startMobileNonMapHeightResize && _ctx.startMobileNonMapHeightResize(...args))),
                  onKeydown: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onMobileNonMapHeightResizeKeydown && _ctx.onMobileNonMapHeightResizeKeydown(...args)))
                }, null, 32))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_v_hover, null, {
                default: _withCtx(({isHovering, props}) => [
                  (false &&!isHovering && !_ctx.smAndUp)
                    ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                        color: "blue",
                        width: '100%'
                      }), {
                        default: _withCtx(() => [...(_cache[99] || (_cache[99] = [
                          _createTextVNode("Tap here to reveal map", -1)
                        ]))]),
                        _: 1
                      }, 16))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_slide_y_transition, { disabled: _ctx.smAndUp }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          (_ctx.narrow)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.selectedLocationText), 1)
                                ]),
                                (_ctx.eclipsePredictionText)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.eclipsePredictionText), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_location_search, {
                            class: "map-search-bottomleft",
                            modelValue: _ctx.searchOpen,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.searchOpen) = $event)),
                            small: "",
                            buttonSize: "xl",
                            "search-provider": _ctx.geocodingInfoForSearch,
                            accentColor: _ctx.accentColor,
                            "open-upward": _ctx.narrow,
                            "escape-container": !_ctx.narrow,
                            onSetLocation: _ctx.setLocationFromSearchFeature,
                            onError: _cache[14] || (_cache[14] = ($event: any) => (_ctx.searchErrorMessage = $event))
                          }, null, 8, ["modelValue", "search-provider", "accentColor", "open-upward", "escape-container", "onSetLocation"])
                        ]),
                        (_ctx.getMyLocation)
                          ? (_openBlock(), _createBlock(_component_icon_button, {
                              key: 0,
                              id: "my-location-overmap",
                              "fa-icon": "location-crosshairs",
                              "fa-size": "2xl",
                              color: _ctx.myLocationColor,
                              "focus-color": _ctx.myLocationColor,
                              "box-shadow": false,
                              "tooltip-text": _ctx.myLocationToolTip,
                              "show-tooltip": !_ctx.mobile,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = (value) => {
                if(value) {
                  (_ctx.$refs.geolocation as any).getLocation();
                  _ctx.showMyLocationDialog = true;
                  _ctx.learnerPath = 'Location';
                }
                else {
                  console.log('geolocation button pressed = false');
                }

              })
                            }, null, 8, ["color", "focus-color", "tooltip-text", "show-tooltip"]))
                          : _createCommentVNode("", true),
                        (_ctx.narrow)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createVNode(_component_icon_button, {
                                id: "eclipse-details-overmap",
                                "md-icon": "sun-clock",
                                "md-size": "24",
                                color: _ctx.accentColor,
                                "focus-color": _ctx.accentColor,
                                "tooltip-text": "View eclipse timing details",
                                "tooltip-location": "start",
                                onActivate: _cache[16] || (_cache[16] = () => { _ctx.showEclipsePredictionSheet = true; })
                              }, null, 8, ["color", "focus-color"]),
                              _createVNode(_component_icon_button, {
                                id: "reset-location-overmap",
                                "fa-icon": "house",
                                "fa-size": "lg",
                                color: _ctx.accentColor,
                                "focus-color": _ctx.accentColor,
                                "box-shadow": false,
                                "tooltip-text": "Reset to Antiguita, Spain",
                                "tooltip-location": "start",
                                onActivate: _cache[17] || (_cache[17] = () => {
                  _ctx.location = _ctx.defaultLocation;
                  _ctx.selectedLocationText = _ctx.defaultLocationText;
                  _ctx.learnerPath = 'Location';
                  // The pin resets to Antiguita, Spain, but the map's own
                  // camera should return to this session's actual
                  // starting view (which is deliberately NOT centered on
                  // Antiguita -- see initialMapOptions), not wherever the
                  // pin ends up. Deferred a tick: the location change
                  // above also triggers location-selector's own
                  // modelValue watcher, which re-centers/zooms the map
                  // on the pin's new position -- calling this after that
                  // watcher runs, rather than before, is what makes it
                  // win instead of being immediately undone by it.
                  _ctx.$nextTick(() => {
                    ((_ctx.$refs.locationSelector as any)?.resetToInitialView)?.();
                  });
                })
                              }, null, 8, ["color", "focus-color"]),
                              (_ctx.withinForecastRange)
                                ? (_openBlock(), _createBlock(_component_icon_button, {
                                    key: 0,
                                    id: "forecast-overmap",
                                    "md-icon": "mdi-cloud-clock",
                                    "md-size": "24",
                                    color: _ctx.accentColor,
                                    "focus-color": _ctx.accentColor,
                                    "box-shadow": false,
                                    "tooltip-text": "August 12 Weather Forecast",
                                    "tooltip-location": "start",
                                    onActivate: _cache[18] || (_cache[18] = () => { _ctx.showForecastSheet = true; })
                                  }, null, 8, ["color", "focus-color"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_location_selector, {
                          ref: "locationSelector",
                          "model-value": _ctx.locationDeg,
                          "onUpdate:modelValue": _ctx.updateLocationFromMap,
                          "place-circle-options": _ctx.placeCircleOptions,
                          "detect-location": false,
                          "map-options": (['Clouds', 'CloudDetail'].includes(_ctx.learnerPath)) ? _ctx.userSelectedMapOptions : _ctx.initialMapOptions,
                          "selected-circle-options": _ctx.selectedCircleOptions,
                          "show-cloud-cover": ['Clouds', 'CloudDetail'].includes(_ctx.learnerPath) && _ctx.cloudCoverData !== null,
                          class: "leaflet-map",
                          "geo-json-files": _ctx.geojson,
                          "selected-cloud-cover": _ctx.selectedCloudCoverData,
                          "cloud-cover-opacity-function": _ctx.sigmoid,
                          "rectangle-degrees": _ctx.rectangleDegrees
                        }, null, 8, ["model-value", "onUpdate:modelValue", "place-circle-options", "map-options", "selected-circle-options", "show-cloud-cover", "geo-json-files", "selected-cloud-cover", "cloud-cover-opacity-function", "rectangle-degrees"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["style", "class"]), [
          [_vShow, _ctx.showGuidedContent]
        ]),
        _withDirectives(_createElementVNode("div", {
          id: "top-container-resize-handle",
          role: "separator",
          "aria-orientation": "horizontal",
          "aria-label": "Resize map area",
          tabindex: "0",
          onMousedown: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.startTopContainerResize && _ctx.startTopContainerResize(...args))),
          onTouchstart: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.startTopContainerResize && _ctx.startTopContainerResize(...args))),
          onKeydown: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onTopContainerResizeKeydown && _ctx.onTopContainerResizeKeydown(...args)))
        }, null, 544), [
          [_vShow, _ctx.showGuidedContent && !_ctx.narrow]
        ])
      ], 2),
      _createVNode(_component_v_dialog, {
        class: "error-dialog",
        style: _normalizeStyle(_ctx.cssVars),
        modelValue: _ctx.showWebGL2Warning,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showWebGL2Warning) = $event)),
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
              _createElementVNode("div", { class: "error-message" }, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, "This app requires WebGL 2")
                ]),
                _createElementVNode("p", { class: "mt-2" }, " Check your browser's settings and enable WebGL 2 (\"graphics acceleration\" on some browsers). "),
                _createElementVNode("p", { class: "mt-2" }, [
                  _createTextVNode(" You can check whether your browser supports WebGL 2 and get assistance "),
                  _createElementVNode("a", {
                    href: "https://get.webgl.org/webgl2/",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, "here"),
                  _createTextVNode(". ")
                ])
              ], -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style", "modelValue"]),
      _createVNode(_component_v_dialog, {
        scrim: "false",
        transition: "slide-y-transition",
        modelValue: _ctx.showInfoSheet,
        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.showInfoSheet) = $event)),
        class: "bottom-sheet",
        id: "text-bottom-sheet",
        style: _normalizeStyle(_ctx.cssVars)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "bottom-sheet-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tabs, {
                modelValue: _ctx.infoTab,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.infoTab) = $event)),
                height: "32px",
                color: _ctx.accentColor,
                "slider-color": _ctx.accentColor,
                id: "tabs",
                dense: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tab, {
                    class: "info-tabs",
                    tabindex: "0"
                  }, {
                    default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                      _createElementVNode("h3", null, "Eclipse Science", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, {
                    class: "info-tabs",
                    tabindex: "0"
                  }, {
                    default: _withCtx(() => [...(_cache[102] || (_cache[102] = [
                      _createElementVNode("h3", null, "User Guide", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "color", "slider-color"]),
              _createElementVNode("div", {
                class: "dialog-close-button",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showInfoSheet = false)),
                onKeyup: _cache[25] || (_cache[25] = _withKeys(($event: any) => (_ctx.showInfoSheet = false), ["enter"])),
                tabindex: "0"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "xmark",
                  size: "xl",
                  color: _ctx.accentColor2
                }, null, 8, ["color"])
              ], 32),
              _createVNode(_component_v_window, {
                modelValue: _ctx.infoTab,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.infoTab) = $event)),
                id: "tab-items",
                class: "no-bottom-border-radius"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_container, { id: "learn-more-content" }, {
                                default: _withCtx(() => [
                                  _cache[105] || (_cache[105] = _createElementVNode("div", { id: "info-text-box" }, [
                                    _createElementVNode("div", { id: "main-info-text" }, [
                                      _createElementVNode("p", null, " On August 12, 2026, Europe will be treated to an awe-inspiring total eclipse. "),
                                      _createElementVNode("p", null, " This interactive lets you explore the August total eclipse from different locations. "),
                                      _createElementVNode("p", { id: "safety-warning" }, " SAFETY FIRST: NEVER look directly at the Sun without proper eye protection. ")
                                    ]),
                                    _createElementVNode("div", { id: "FAQ" }, [
                                      _createElementVNode("details", null, [
                                        _createElementVNode("summary", null, " What causes Solar Eclipses? "),
                                        _createElementVNode("p", null, " A solar eclipse happens when the Moon passes between the Earth and the Sun and blocks the Sun from our view. Partial eclipses occur about every 6 months, somewhere on the Earth. ")
                                      ]),
                                      _createElementVNode("details", null, [
                                        _createElementVNode("summary", null, " Total? Annular? What is the difference?"),
                                        _createElementVNode("p", null, [
                                          _createTextVNode(" During a "),
                                          _createElementVNode("strong", null, "total eclipse"),
                                          _createTextVNode(", the Moon covers the entire face of the Sun. Because the Moon doesn't orbit the Earth in a perfect circle, sometimes it is farther away from Earth and appears smaller. When this happens, the Moon doesn't cover the entire face of the Sun. During the eclipse we can still see a bright ring of light around the Moon, sometimes called the \"Ring of Fire.\" This is called an "),
                                          _createElementVNode("strong", null, "annular Eclipse"),
                                          _createTextVNode(". ")
                                        ])
                                      ]),
                                      _createElementVNode("details", null, [
                                        _createElementVNode("summary", null, " What is the wispy haze around the Sun during a Total Solar Eclipse?"),
                                        _createElementVNode("p", null, [
                                          _createTextVNode(" The "),
                                          _createElementVNode("strong", null, "corona"),
                                          _createTextVNode(" is the outermost layer of the Sun's atmosphere, and it is made up of extremely hot, glowing gas. We usually can't see the corona because the Sun's surface shines so much more brightly. During a total solar eclipse, the Moon blocks light from the surface of the Sun, making it possible to see the ethereally beautiful corona. ")
                                        ])
                                      ]),
                                      _createElementVNode("details", null, [
                                        _createElementVNode("summary", null, " Why can only some places see the eclipse?"),
                                        _createElementVNode("p", null, " An eclipse is caused by the Moon casting a shadow on the Earth. People who are directly behind the Moon will see an annular or total eclipse. As the Moon moves in its orbit around Earth, and as Earth rotates, the location of the shadow will move, sweeping out a path across the surface of the Earth. For a larger number of people who are not directly behind the moon, a smaller amount of the Sun will be blocked, causing a partial eclipse. Even further outside the shadow the Sun will not be blocked at all, and there will be no eclipse visible. "),
                                        _createElementVNode("p", null, " The animated figure shows that the Moon's shadow on Earth has two distinct regions. The darker part of the shadow is directly behind the Moon, where people will experience an annular or total eclipse. The lighter part of the shadow falls where people on Earth will see a partial solar eclipse. ")
                                      ]),
                                      _createElementVNode("details", null, [
                                        _createElementVNode("summary", null, "How precise are location and timing predications in this Data Story?"),
                                        _createElementVNode("p", null, " You may notice some discrepancies in the reported eclipse percentages or with eclipse start and end times compared with other predictions. This is caused by limitations in precision for the calculations used to display the locations and sizes of the Sun and Moon on your screen. Totality timing predictions in this Data Story should be accurate to within about 15 seconds. ")
                                      ]),
                                      _createElementVNode("details", null, [
                                        _createElementVNode("summary", null, "Where can I learn more?"),
                                        _createElementVNode("div", { class: "p" }, [
                                          _createTextVNode(" Check out "),
                                          _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                              _createTextVNode(" Infiniscope's Kingdom in Peril lessons on eclipses, available in "),
                                              _createElementVNode("a", {
                                                href: "https://infiniscope.org/collection/3",
                                                target: "_blank",
                                                rel: "noopener noreferrer"
                                              }, "English"),
                                              _createTextVNode(" and "),
                                              _createElementVNode("a", {
                                                href: "https://infiniscope.org/collection/6",
                                                target: "_blank",
                                                rel: "noopener noreferrer"
                                              }, "Spanish")
                                            ]),
                                            _createElementVNode("li", null, [
                                              _createTextVNode(" Fiske Planetarium's "),
                                              _createElementVNode("a", {
                                                href: "https://www.colorado.edu/fiske/projects/science-through-shadows",
                                                target: "_blank",
                                                rel: "noopener noreferrer"
                                              }, "Science Through Shadows"),
                                              _createTextVNode(" videos ")
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ], -1)),
                                  _createElementVNode("figure", null, [
                                    _createVNode(_component_gif_play_pause, {
                                      startPaused: "",
                                      gif: require("./assets/eclipse.gif"),
                                      still: require("./assets/eclipse_static.gif"),
                                      alt: "Animated schematic of a solar eclipse showing how the Moon moves between the Sun and Earth."
                                    }, null, 8, ["gif", "still"]),
                                    _cache[103] || (_cache[103] = _createElementVNode("figcaption", null, "Image credit: NASA Goddard / Katy Mersmann", -1)),
                                    _cache[104] || (_cache[104] = _createElementVNode("div", { class: "disclaimer" }, "Not to scale", -1))
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_container, { id: "user-guide" }, {
                                default: _withCtx(() => [
                                  _cache[149] || (_cache[149] = _createElementVNode("p", { style: {"font-size":"calc(1.1 * var(--default-font-size))"} }, " This Cosmic Data Story allows you to display the August 12, 2026 Total Solar Eclipse from any location. ", -1)),
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.showIntroAtLaunch,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.showIntroAtLaunch) = $event)),
                                    onKeyup: _cache[27] || (_cache[27] = _withKeys(($event: any) => (_ctx.showIntroAtLaunch = !_ctx.showIntroAtLaunch), ["enter"])),
                                    label: "Show quickstart introduction when app opens",
                                    color: _ctx.accentColor,
                                    "hide-details": "",
                                    density: "compact",
                                    class: "mb-5 show-intro-checkbox"
                                  }, null, 8, ["modelValue", "color"]),
                                  _createVNode(_component_v_row, { align: "center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_chip, {
                                            label: "",
                                            outlined: ""
                                          }, {
                                            default: _withCtx(() => [...(_cache[106] || (_cache[106] = [
                                              _createTextVNode(" Pan ", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "8",
                                        class: "pt-1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "press + drag" : "click + drag"), 1),
                                          _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "or") + " ", 1),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "" : "W-A-S-D"), 1),
                                          _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "keys") + " ", 1),
                                          _cache[107] || (_cache[107] = _createElementVNode("br", null, null, -1)),
                                          _cache[108] || (_cache[108] = _createTextVNode("(Disabled if tracking Sun)", -1)),
                                          _cache[109] || (_cache[109] = _createElementVNode("br", null, null, -1))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, { align: "center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_chip, {
                                            label: "",
                                            outlined: ""
                                          }, {
                                            default: _withCtx(() => [...(_cache[110] || (_cache[110] = [
                                              _createTextVNode(" Zoom ", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "8",
                                        class: "pt-1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "pinch in and out" : "scroll in and out"), 1),
                                          _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "or") + " ", 1),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "" : "I-O"), 1),
                                          _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "keys"), 1),
                                          _cache[111] || (_cache[111] = _createElementVNode("br", null, null, -1))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_27, [
                                            _cache[141] || (_cache[141] = _createElementVNode("h4", { class: "user-guide-header" }, "Map Options:", -1)),
                                            (!_ctx.showNewMobileUI)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_28, "(Top of the screen)"))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_29, [
                                                  _cache[112] || (_cache[112] = _createTextVNode(" (Tap ", -1)),
                                                  _createVNode(_component_v_icon, {
                                                    class: "bullet-icon",
                                                    icon: "mdi-map-search",
                                                    size: "large"
                                                  }),
                                                  _cache[113] || (_cache[113] = _createTextVNode(" to open) ", -1))
                                                ])),
                                            _createElementVNode("ul", _hoisted_30, [
                                              _cache[117] || (_cache[117] = _createElementVNode("li", null, " Type a location into the search box to find a specific location. ", -1)),
                                              _createElementVNode("li", null, [
                                                _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                _createVNode(_component_font_awesome_icon, {
                                                  class: "bullet-icon",
                                                  icon: "location-crosshairs",
                                                  size: "lg"
                                                }),
                                                _cache[114] || (_cache[114] = _createTextVNode(" to view from ", -1)),
                                                _cache[115] || (_cache[115] = _createElementVNode("strong", null, "My Location", -1)),
                                                _cache[116] || (_cache[116] = _createTextVNode(". (If icon is grayed out, consult your device's user guide to enable location services. This feature works most reliably on Chrome and might not be available on every browser+operating system combination.) ", -1))
                                              ])
                                            ]),
                                            _createVNode(_component_v_divider, {
                                              thickness: "2px",
                                              class: "solid-divider"
                                            }),
                                            _cache[142] || (_cache[142] = _createElementVNode("h4", { class: "user-guide-header" }, "Time Controls:", -1)),
                                            _cache[143] || (_cache[143] = _createElementVNode("p", null, "(Bottom of the screen)", -1)),
                                            _cache[144] || (_cache[144] = _createElementVNode("p", null, " By default, time is moving forward at 500x the real speed. Time slows down to 10x the real speed as the eclipse approaches totality. ", -1)),
                                            _createElementVNode("ul", _hoisted_31, [
                                              _createElementVNode("li", null, [
                                                _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                _createVNode(_component_font_awesome_icon, {
                                                  class: "bullet-icon",
                                                  icon: "play",
                                                  size: "lg"
                                                }),
                                                _cache[118] || (_cache[118] = _createTextVNode("/ ", -1)),
                                                _createVNode(_component_font_awesome_icon, {
                                                  class: "bullet-icon",
                                                  icon: "pause",
                                                  size: "lg"
                                                }),
                                                _cache[119] || (_cache[119] = _createTextVNode(" to play or pause time. ", -1))
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                _createVNode(_component_font_awesome_icon, {
                                                  class: "bullet-icon",
                                                  icon: "angles-down",
                                                  size: "lg"
                                                }),
                                                _cache[120] || (_cache[120] = _createTextVNode(" to decrease speed by 5x. ", -1))
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                _createVNode(_component_font_awesome_icon, {
                                                  class: "bullet-icon",
                                                  icon: "angles-up",
                                                  size: "lg"
                                                }),
                                                _cache[121] || (_cache[121] = _createTextVNode(" to increase speed by 5x. ", -1))
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                _createVNode(_component_v_icon, {
                                                  class: "bullet-icon",
                                                  icon: "mdi-step-backward-2",
                                                  size: "medium"
                                                }),
                                                _cache[122] || (_cache[122] = _createTextVNode("/ ", -1)),
                                                _createVNode(_component_v_icon, {
                                                  class: "bullet-icon",
                                                  icon: "mdi-step-forward-2",
                                                  size: "medium"
                                                }),
                                                _cache[123] || (_cache[123] = _createTextVNode(" to play time backward or forward. ", -1))
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                _createVNode(_component_font_awesome_icon, {
                                                  class: "bullet-icon",
                                                  icon: "house",
                                                  size: "lg"
                                                }),
                                                _cache[124] || (_cache[124] = _createTextVNode(" to reset starting time, speed, and location. ", -1))
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                _createVNode(_component_font_awesome_icon, {
                                                  class: "bullet-icon",
                                                  icon: "gauge-high",
                                                  size: "lg"
                                                }),
                                                _cache[125] || (_cache[125] = _createTextVNode(" to open more speed controls. ", -1))
                                              ]),
                                              _createElementVNode("ul", null, [
                                                _cache[127] || (_cache[127] = _createElementVNode("li", { class: "ml-5" }, " Use the slider to fine-tune desired speed. ", -1)),
                                                _createElementVNode("li", _hoisted_32, [
                                                  _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                  _createVNode(_component_font_awesome_icon, {
                                                    class: "bullet-icon",
                                                    icon: "times",
                                                    size: "lg"
                                                  }),
                                                  _cache[126] || (_cache[126] = _createTextVNode(" to close speed controls. ", -1))
                                                ])
                                              ]),
                                              _createElementVNode("li", null, [
                                                _cache[128] || (_cache[128] = _createTextVNode(" Drag ", -1)),
                                                _createVNode(_component_v_icon, {
                                                  class: "bullet-icon",
                                                  icon: "mdi-circle",
                                                  size: "medium"
                                                }),
                                                _cache[129] || (_cache[129] = _createTextVNode(" along the main slider to move to any time. ", -1))
                                              ])
                                            ]),
                                            _createVNode(_component_v_divider, {
                                              thickness: "2px",
                                              class: "solid-divider"
                                            }),
                                            _cache[145] || (_cache[145] = _createElementVNode("h4", { class: "user-guide-header" }, "Location and Eclipse Status:", -1)),
                                            _cache[146] || (_cache[146] = _createElementVNode("p", null, "(Upper-left of the screen)", -1)),
                                            _createElementVNode("ul", _hoisted_33, [
                                              _cache[133] || (_cache[133] = _createElementVNode("li", null, " Selected Location: the location currently displayed in the view. ", -1)),
                                              _cache[134] || (_cache[134] = _createElementVNode("li", null, [
                                                _createTextVNode(" Eclipse Status: The type of eclipse (total, partial, or no eclipse) visible from your selected location on August 12, 2026. "),
                                                _createElementVNode("ul", null, [
                                                  _createElementVNode("li", { class: "ml-5" }, " If Total: (amount of time in totality) "),
                                                  _createElementVNode("li", { class: "ml-5" }, " If Partial: (Maximum % eclipsed). ")
                                                ])
                                              ], -1)),
                                              _createElementVNode("li", null, [
                                                _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                _createVNode(_component_v_icon, {
                                                  class: "bullet-icon",
                                                  icon: "mdi-sun-clock",
                                                  size: "large"
                                                }),
                                                _cache[130] || (_cache[130] = _createTextVNode(" to display detailed ", -1)),
                                                _cache[131] || (_cache[131] = _createElementVNode("span", { class: "user-guide-emphasis-white" }, "eclipse timing", -1)),
                                                _cache[132] || (_cache[132] = _createTextVNode(" predictions for your selected location. ", -1))
                                              ])
                                            ]),
                                            _createVNode(_component_v_divider, {
                                              thickness: "2px",
                                              class: "solid-divider"
                                            }),
                                            _cache[147] || (_cache[147] = _createElementVNode("h4", { class: "user-guide-header" }, "Display Options:", -1)),
                                            _cache[148] || (_cache[148] = _createElementVNode("p", null, "(Upper-right of the screen)", -1)),
                                            _createElementVNode("ul", _hoisted_34, [
                                              _createElementVNode("li", null, [
                                                _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                _createVNode(_component_font_awesome_icon, {
                                                  class: "bullet-icon",
                                                  icon: "sliders",
                                                  size: "lg"
                                                }),
                                                _cache[135] || (_cache[135] = _createTextVNode(" to open controls. ", -1)),
                                                _cache[136] || (_cache[136] = _createElementVNode("ul", null, [
                                                  _createElementVNode("li", { class: "ml-5" }, [
                                                    _createElementVNode("span", { class: "user-guide-emphasis-white" }, "Track Sun:"),
                                                    _createTextVNode(" Camera follows the Sun. Turn off to keep the camera fixed and show motion of Sun (and Moon) against the sky. ")
                                                  ]),
                                                  _createElementVNode("li", { class: "ml-5" }, [
                                                    _createElementVNode("span", { class: "user-guide-emphasis-white" }, "Horizon / Sky:"),
                                                    _createTextVNode(" Display a virtual \"ground\" that delineates where the Sun rises and sets. Show a blue sky when the Sun is above the horizon. ")
                                                  ]),
                                                  _createElementVNode("li", { class: "ml-5" }, [
                                                    _createElementVNode("span", { class: "user-guide-emphasis-white" }, "Sky Grid:"),
                                                    _createTextVNode(" Display altitude/azimuth grid with cardinal directions. ")
                                                  ]),
                                                  _createElementVNode("li", { class: "ml-5" }, [
                                                    _createElementVNode("span", { class: "user-guide-emphasis-white" }, "Visible Moon:"),
                                                    _createTextVNode(" Solar Eclipses occur during a New Moon, when the Moon is not normally visible in the sky. This option makes it easier to see the Moon against the sky. ")
                                                  ])
                                                ], -1))
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                _createVNode(_component_font_awesome_icon, {
                                                  class: "bullet-icon",
                                                  icon: "circle-info",
                                                  size: "lg"
                                                }),
                                                _cache[137] || (_cache[137] = _createTextVNode(" to open this guide. ", -1))
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createTextVNode(_toDisplayString(_ctx.touchscreen ? "Tap" : "Click") + " ", 1),
                                                _createVNode(_component_font_awesome_icon, {
                                                  class: "bullet-icon",
                                                  icon: "share-nodes",
                                                  size: "lg"
                                                }),
                                                _cache[138] || (_cache[138] = _createTextVNode(" to copy ", -1)),
                                                _cache[139] || (_cache[139] = _createElementVNode("strong", null, "share-url", -1)),
                                                _cache[140] || (_cache[140] = _createTextVNode(" for a specific location. ", -1))
                                              ])
                                            ])
                                          ]),
                                          _createVNode(_component_v_divider, {
                                            thickness: "2px",
                                            class: "solid-divider"
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _cache[150] || (_cache[150] = _createElementVNode("div", { id: "text-credits" }, [
                                    _createElementVNode("h3", null, "Credits:"),
                                    _createElementVNode("p", null, [
                                      _createTextVNode("Atmospheric Physicist "),
                                      _createElementVNode("a", {
                                        href: "https://www.cfa.harvard.edu/people/caroline-nowlan",
                                        target: "_blank",
                                        rel: "noopener noreferrer"
                                      }, "Caroline Nowlan"),
                                      _createTextVNode(" provided valuable guidance on interpreting the "),
                                      _createElementVNode("a", {
                                        href: "https://neo.gsfc.nasa.gov/view.php?datasetId=MYDAL2_E_CLD_FR&date=2023-04-07",
                                        target: "_blank",
                                        rel: "noopener noreferrer"
                                      }, "MODIS Cloud Cover"),
                                      _createTextVNode(" data.")
                                    ]),
                                    _createElementVNode("p", null, [
                                      _createTextVNode("The path of totality data are from "),
                                      _createElementVNode("a", {
                                        href: "https://nso.edu/for-public/eclipse-map-2026/",
                                        target: "_blank",
                                        rel: "noopener noreferrer"
                                      }, "National Solar Observatory"),
                                      _createTextVNode(".")
                                    ]),
                                    _createElementVNode("p", null, [
                                      _createTextVNode("Eclipse Timing Predictions are by "),
                                      _createElementVNode("a", {
                                        href: "https://eclipse.gsfc.nasa.gov/JSEX/JSEX-NA.html",
                                        target: "_blank",
                                        rel: "noopener noreferrer"
                                      }, "Fred Espenak and Chris O'Byrne"),
                                      _createTextVNode(" (NASA's GSFC). "),
                                      _createElementVNode("em", null, "Adapted for TypeScript by CosmicDS Team")
                                    ]),
                                    _createElementVNode("p", null, "Image of Sun is courtesy of NASA/SDO and the AIA, EVE, and HMI science teams."),
                                    _createElementVNode("p", null, "This Cosmic Data Story is powered by WorldWide Telescope (WWT)."),
                                    _createElementVNode("h4", null, [
                                      _createElementVNode("a", {
                                        href: "https://www.cosmicds.cfa.harvard.edu/",
                                        target: "_blank",
                                        rel: "noopener noreferrer"
                                      }, "CosmicDS"),
                                      _createTextVNode(" Team:")
                                    ]),
                                    _createTextVNode(" John Lewis"),
                                    _createElementVNode("br"),
                                    _createTextVNode(" Jon Carifio"),
                                    _createElementVNode("br"),
                                    _createTextVNode(" Pat Udomprasert"),
                                    _createElementVNode("br"),
                                    _createTextVNode(" Alyssa Goodman"),
                                    _createElementVNode("br"),
                                    _createTextVNode(" Harry Houghton"),
                                    _createElementVNode("br"),
                                    _createTextVNode(" Evaluator: Sue Sunbury"),
                                    _createElementVNode("br"),
                                    _createElementVNode("h4", null, [
                                      _createElementVNode("a", {
                                        href: "https://www.worldwidetelescope.org/",
                                        target: "_blank",
                                        rel: "noopener noreferrer"
                                      }, "WorldWide Telescope"),
                                      _createTextVNode(" Team:")
                                    ]),
                                    _createTextVNode(" Peter Williams"),
                                    _createElementVNode("br"),
                                    _createTextVNode(" A. David Weigel"),
                                    _createElementVNode("br"),
                                    _createTextVNode(" Jon Carifio"),
                                    _createElementVNode("br")
                                  ], -1)),
                                  _createVNode(_component_funding_acknowledgment)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "style"]),
      _createElementVNode("div", _hoisted_35, [
        ((_ctx.sunPosition.altRad < -.25 * Math.PI/180))
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("p", null, " The Sun has " + _toDisplayString(_ctx.sunPosition.azRad < Math.PI ? 'not risen yet' : 'set'), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_WorldWideTelescope, { "wwt-namespace": _ctx.wwtNamespace }, null, 8, ["wwt-namespace"]),
        (_ctx.currentFractionEclipsed > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              id: "eclipse-percent-indicator",
              style: _normalizeStyle({ top: _ctx.eclipsedIndicatorTop + 'px', left: _ctx.eclipsedIndicatorLeft + 'px' })
            }, _toDisplayString(_ctx.percentEclipsedText), 5))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            id: "left-buttons-wrapper",
            class: _normalizeClass([!_ctx.showGuidedContent ?'budge' : ''])
          }, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", {
                id: "location-status-box",
                class: _normalizeClass({ 'non-interactive': !_ctx.narrow }),
                onClick: _cache[30] || (_cache[30] = () => {
              if (!_ctx.narrow) {
                return;
              }
              _ctx.showGuidedContent = true;
              _ctx.onResize();
              })
              }, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.selectedLocationText), 1)
                ]),
                _createElementVNode("div", null, _toDisplayString(_ctx.selectedLocalDateString), 1),
                (_ctx.eclipsePredictionText)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.eclipsePredictionText), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_40, [
                (_ctx.narrow)
                  ? (_openBlock(), _createBlock(_component_icon_button, {
                      key: 0,
                      modelValue: _ctx.showGuidedContent,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.showGuidedContent) = $event)),
                      id: "show-guided-content-mobile",
                      "md-icon": "map-search",
                      "md-size": "20",
                      color: _ctx.accentColor,
                      "focus-color": _ctx.accentColor,
                      "tooltip-text": "Map and Weather",
                      "tooltip-location": 'bottom',
                      "show-tooltip": !_ctx.mobile,
                      "box-shadow": false,
                      onActivate: _ctx.onResize
                    }, null, 8, ["modelValue", "color", "focus-color", "show-tooltip", "onActivate"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_icon_button, {
                  id: "eclipse-details-button",
                  "md-icon": "sun-clock",
                  "md-size": _ctx.showNewMobileUI ? '20' : '24',
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": "View eclipse timing details",
                  "tooltip-location": "start",
                  onActivate: _cache[32] || (_cache[32] = () => { _ctx.showEclipsePredictionSheet = true; })
                }, null, 8, ["md-size", "color", "focus-color"])
              ])
            ]),
            _createElementVNode("div", {
              id: "location-progress",
              class: _normalizeClass([!_ctx.showGuidedContent ?'budge' : ''])
            }, [
              _createVNode(_component_geolocation_button, {
                color: _ctx.accentColor,
                "show-text-progress": true,
                "hide-button": "",
                "show-progress-circle": "",
                ref: "geolocation",
                onGeolocation: _cache[33] || (_cache[33] = (loc) => {
              _ctx.myLocation = {
                latitudeDeg: loc.latitude,
                longitudeDeg: loc.longitude
              };
              _ctx.showMyLocationDialog = false;

              if (_ctx.myLocation.latitudeDeg !== _ctx.locationDeg.latitudeDeg || _ctx.myLocation.longitudeDeg !== _ctx.locationDeg.longitudeDeg) {
                _ctx.locationDeg = _ctx.myLocation;
                _ctx.$nextTick(() => {
                  _ctx.updateSelectedLocationText();
                });
              }
            }),
                onError: _cache[34] || (_cache[34] = (error) => {
              _ctx.$notify({
                group: 'geolocation-error',
                title: 'Error',
                text: error.message,
                type: 'error',
              });
              if (error.code === 1) {
                _ctx.geolocationPermission = 'denied';
              }
              console.log(error);
            }),
                onPermission: _cache[35] || (_cache[35] = (p) => {
              _ctx.geolocationPermission = p;
              // we're always gonna show the button,
              // just leaving this if we wanna change
              if (p == 'granted') {
                _ctx.getMyLocation = true;
              } else if (p == 'prompt') {
                _ctx.getMyLocation = true;
              } else {
                _ctx.getMyLocation = true;
              }
            })
              }, null, 8, ["color"])
            ], 2)
          ], 2)
        ]),
        _createVNode(_component_v_overlay, {
          "model-value": _ctx.showSplashScreen,
          absolute: "",
          opacity: "0.6",
          style: _normalizeStyle(_ctx.cssVars),
          id: "splash-overlay",
          class: _normalizeClass([_ctx.showNewMobileUI ? 'new-mobile-ui' : ''])
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              id: "splash-screen",
              style: _normalizeStyle(_ctx.cssVars)
            }, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", {
                  id: "close-splash-button",
                  tabindex: "0",
                  onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.closeSplashScreen && _ctx.closeSplashScreen(...args))),
                  onKeyup: _cache[37] || (_cache[37] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeSplashScreen && _ctx.closeSplashScreen(...args)), ["enter"]))
                }, "×", 32),
                _cache[151] || (_cache[151] = _createElementVNode("div", { id: "splash-screen-text" }, [
                  _createElementVNode("p", null, "See how the "),
                  _createElementVNode("p", { class: "highlight" }, "August 12, 2026"),
                  _createElementVNode("p", { class: "highlight" }, "TOTAL Solar Eclipse"),
                  _createElementVNode("p", null, [
                    _createTextVNode("will look from any "),
                    _createElementVNode("span", { class: "highlight" }, "location")
                  ])
                ], -1))
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  class: "splash-get-started",
                  onClick: _ctx.closeSplashScreen,
                  color: _ctx.accentColor,
                  density: _ctx.xSmallSize ? 'compact' : 'default',
                  size: "x-large",
                  variant: "elevated",
                  rounded: "lg"
                }, {
                  default: _withCtx(() => [...(_cache[152] || (_cache[152] = [
                    _createTextVNode(" Get Started ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick", "color", "density"])
              ]),
              (!_ctx.narrow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    (_ctx.onDayOfEclipse)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                          _createVNode(_component_v_icon, {
                            icon: "mdi-creation",
                            size: "small",
                            class: "bullet-icon"
                          }),
                          _cache[153] || (_cache[153] = _createTextVNode(" New! NOW button, active starting at 6:40am EDT ", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _cache[154] || (_cache[154] = _createElementVNode("div", { id: "splash-screen-acknowledgements" }, [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "Cosmic Data Stories Eclipse logo",
                    class: "eclipse-ds-logo"
                  })
                ]),
                _createTextVNode(" Brought to you by "),
                _createElementVNode("a", {
                  href: "https://www.cosmicds.cfa.harvard.edu/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "Cosmic Data Stories"),
                _createTextVNode(" and "),
                _createElementVNode("a", {
                  href: "https://www.worldwidetelescope.org/home/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "WorldWide Telescope"),
                _createTextVNode(". ")
              ], -1))
            ], 4)), [
              [_directive_click_outside, _ctx.closeSplashScreen]
            ])
          ]),
          _: 1
        }, 8, ["model-value", "style", "class"]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_44, [...(_cache[155] || (_cache[155] = [
              _createElementVNode("div", { class: "container" }, [
                _createElementVNode("div", { class: "spinner" }),
                _createElementVNode("p", null, "Loading …")
              ], -1)
            ]))], 512), [
              [_vShow, _ctx.isLoading]
            ])
          ]),
          _: 1
        }),
        (_ctx.showNewMobileUI && _ctx.introSlide === 2)
          ? (_openBlock(), _createBlock(_component_v_overlay, {
              key: 2,
              modelValue: _ctx.inIntro,
              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.inIntro) = $event)),
              id: "intro-overlay-mobile",
              opacity: "1",
              scrim: false,
              style: _normalizeStyle(_ctx.cssVars)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_v_icon, {
                        class: "the-arrow",
                        color: _ctx.accentColor,
                        size: Math.min(_ctx.$vuetify.display.width*0.16,_ctx.$vuetify.display.height*0.16,70)
                      }, {
                        default: _withCtx(() => [...(_cache[156] || (_cache[156] = [
                          _createTextVNode("mdi-arrow-up-bold", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color", "size"])
                    ]),
                    _cache[157] || (_cache[157] = _createElementVNode("div", { class: "inst-text" }, [
                      _createTextVNode(" Location,"),
                      _createElementVNode("br"),
                      _createTextVNode(" Path, + "),
                      _createElementVNode("br"),
                      _createTextVNode(" Timing ")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_v_icon, {
                        class: "the-arrow",
                        color: _ctx.accentColor,
                        size: Math.min(_ctx.$vuetify.display.width*0.16,_ctx.$vuetify.display.height*0.16,70)
                      }, {
                        default: _withCtx(() => [...(_cache[158] || (_cache[158] = [
                          _createTextVNode("mdi-arrow-up-bold", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color", "size"])
                    ]),
                    _cache[159] || (_cache[159] = _createElementVNode("div", { class: "inst-text" }, [
                      _createTextVNode(" Settings, "),
                      _createElementVNode("br"),
                      _createTextVNode(" Info + "),
                      _createElementVNode("br"),
                      _createTextVNode(" Sharing ")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_v_icon, {
                        class: "the-arrow",
                        color: _ctx.accentColor,
                        size: Math.min(_ctx.$vuetify.display.width*0.16,_ctx.$vuetify.display.height*0.16,70)
                      }, {
                        default: _withCtx(() => [...(_cache[160] || (_cache[160] = [
                          _createTextVNode("mdi-arrow-up-bold", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color", "size"])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      (_ctx.onDayOfEclipse)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("New! Set time to \"Now,\" or control time yourself!")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("Control time yourself!")
                          ], 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_v_btn, {
                      class: "intro-back-button",
                      color: _ctx.accentColor,
                      onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.introSlide--)),
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [...(_cache[161] || (_cache[161] = [
                        _createTextVNode(" Back ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_v_btn, {
                      class: "intro-next-button",
                      color: _ctx.accentColor,
                      onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.introSlide++)),
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [...(_cache[162] || (_cache[162] = [
                        _createTextVNode(" Let's go! ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["color"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "style"]))
          : _createCommentVNode("", true),
        (!_ctx.showNewMobileUI && _ctx.introSlide === 2)
          ? (_openBlock(), _createBlock(_component_v_overlay, {
              key: 3,
              modelValue: _ctx.inIntro,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.inIntro) = $event)),
              id: "intro-overlay-desktop",
              opacity: "1",
              scrim: false,
              style: _normalizeStyle(_ctx.cssVars)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_v_icon, {
                        class: "the-arrow",
                        color: _ctx.accentColor,
                        size: Math.min(_ctx.$vuetify.display.width*0.07,_ctx.$vuetify.display.height*0.07,48)
                      }, {
                        default: _withCtx(() => [...(_cache[163] || (_cache[163] = [
                          _createTextVNode("mdi-arrow-up-bold", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color", "size"])
                    ]),
                    _cache[164] || (_cache[164] = _createElementVNode("div", { class: "inst-text" }, [
                      _createTextVNode(" Location"),
                      _createElementVNode("br"),
                      _createTextVNode("+ Timing ")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_component_v_icon, {
                        class: "the-arrow",
                        color: _ctx.accentColor,
                        size: Math.min(_ctx.$vuetify.display.width*0.07,_ctx.$vuetify.display.height*0.07,48)
                      }, {
                        default: _withCtx(() => [...(_cache[165] || (_cache[165] = [
                          _createTextVNode("mdi-arrow-up-bold", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color", "size"])
                    ]),
                    _cache[166] || (_cache[166] = _createElementVNode("div", { class: "inst-text" }, [
                      _createTextVNode(" Eclipse path "),
                      _createElementVNode("br"),
                      _createTextVNode("+ weather ")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_v_icon, {
                        class: "the-arrow",
                        color: _ctx.accentColor,
                        size: Math.min(_ctx.$vuetify.display.width*0.07,_ctx.$vuetify.display.height*0.07,48)
                      }, {
                        default: _withCtx(() => [...(_cache[167] || (_cache[167] = [
                          _createTextVNode("mdi-arrow-up-bold", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color", "size"])
                    ]),
                    _cache[168] || (_cache[168] = _createElementVNode("div", { class: "inst-text" }, [
                      _createTextVNode(" Settings, "),
                      _createElementVNode("br"),
                      _createTextVNode(" Info +"),
                      _createElementVNode("br"),
                      _createTextVNode(" Sharing ")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(_component_v_btn, {
                      class: "intro-back-button",
                      color: _ctx.accentColor,
                      onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.introSlide--)),
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [...(_cache[169] || (_cache[169] = [
                        _createTextVNode(" Back ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["color"]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_v_icon, {
                          class: "the-arrow",
                          color: _ctx.accentColor,
                          size: Math.min(_ctx.$vuetify.display.width*0.07,_ctx.$vuetify.display.height*0.07,48)
                        }, {
                          default: _withCtx(() => [...(_cache[170] || (_cache[170] = [
                            _createTextVNode("mdi-arrow-up-bold", -1)
                          ]))]),
                          _: 1
                        }, 8, ["color", "size"])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        (_ctx.onDayOfEclipse)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("New! Set time to \"Now,\" or control time yourself!")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Control time yourself!")
                            ], 64))
                      ])
                    ]),
                    _createVNode(_component_v_btn, {
                      class: "intro-next-button",
                      color: _ctx.accentColor,
                      onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.introSlide++)),
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [...(_cache[171] || (_cache[171] = [
                        _createTextVNode(" Let's go! ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["color"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "style"]))
          : _createCommentVNode("", true),
        (_ctx.introSlide === 1)
          ? (_openBlock(), _createBlock(_component_v_dialog, {
              key: 4,
              modelValue: _ctx.inIntro,
              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.inIntro) = $event)),
              id: "intro-dialog",
              style: _normalizeStyle(_ctx.cssVars),
              scrim: false,
              persistent: false
            }, {
              default: _withCtx(() => [
                (_ctx.inIntro)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                      _createVNode(_component_v_window, {
                        modelValue: _ctx.introSlide,
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.introSlide) = $event))
                      }, {
                        additional: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "dialog-close-button",
                            onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.inIntro = !_ctx.inIntro)),
                            onKeyup: _cache[45] || (_cache[45] = _withKeys(($event: any) => (_ctx.inIntro = !_ctx.inIntro), ["enter"])),
                            tabindex: "0"
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              size: "xl",
                              color: _ctx.accentColor2,
                              icon: "xmark"
                            }, null, 8, ["color"])
                          ], 32)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_window_item, { value: 1 }, {
                            default: _withCtx(() => [...(_cache[172] || (_cache[172] = [
                              _createElementVNode("div", { class: "intro-text" }, [
                                _createElementVNode("p", null, [
                                  _createTextVNode(" On August 12, 2026, a lucky stretch of Spain, Iceland, and Greenland will witness an awe-inspiring "),
                                  _createElementVNode("b", null, "total eclipse"),
                                  _createTextVNode(". ")
                                ]),
                                _createElementVNode("p", null, [
                                  _createTextVNode(" Other parts of Europe will see a "),
                                  _createElementVNode("em", null, "partial"),
                                  _createTextVNode(" eclipse, where the Moon blocks out some, but not all of the Sun's light. ")
                                ]),
                                _createElementVNode("p", null, " Choose your location on the map to see what the eclipse will look like where you are, and what the average cloud coverage has been during the week of August 12 from 2003–2023. ")
                              ], -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_checkbox, {
                            modelValue: _ctx.dontShowIntro,
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.dontShowIntro) = $event)),
                            onKeyup: _cache[48] || (_cache[48] = _withKeys(($event: any) => (_ctx.dontShowIntro = !_ctx.dontShowIntro), ["enter"])),
                            label: "Don't show this introduction at launch",
                            color: _ctx.accentColor,
                            "hide-details": ""
                          }, null, 8, ["modelValue", "color"])
                        ]),
                        _createVNode(_component_v_btn, {
                          class: "intro-next-button",
                          color: _ctx.accentColor,
                          onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.introSlide++)),
                          elevation: "0"
                        }, {
                          default: _withCtx(() => [...(_cache[173] || (_cache[173] = [
                            _createTextVNode(" Next ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["color"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "style"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          id: "top-wwt-content",
          class: _normalizeClass([!_ctx.showGuidedContent ? 'budge' : ''])
        }, [
          _createElementVNode("div", _hoisted_67, [
            _createVNode(_component_icon_button, {
              id: "share",
              "fa-icon": "share-nodes",
              color: _ctx.accentColor,
              "focus-color": _ctx.accentColor,
              "box-shadow": false,
              "tooltip-text": "Share view of this location",
              "show-tooltip": !_ctx.mobile,
              onActivate: _ctx.copyShareURL,
              faSize: "lg"
            }, null, 8, ["color", "focus-color", "show-tooltip", "onActivate"]),
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showInfoSheet,
              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.showInfoSheet) = $event)),
              id: "info-button",
              "fa-icon": "circle-info",
              "fa-size": "lg",
              color: _ctx.accentColor,
              "focus-color": _ctx.accentColor,
              "tooltip-text": _ctx.showInfoSheet ? null : 'Information & User Guide',
              "tooltip-location": 'bottom',
              "show-tooltip": !_ctx.mobile,
              "box-shadow": false
            }, null, 8, ["modelValue", "color", "focus-color", "tooltip-text", "show-tooltip"]),
            _createElementVNode("div", _hoisted_68, [
              _createVNode(_component_icon_button, {
                modelValue: _ctx.showControls,
                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.showControls) = $event)),
                id: "controls-toggle",
                "fa-icon": _ctx.showControls ? 'xmark' : 'sliders',
                "fa-size": "lg",
                color: _ctx.accentColor,
                "focus-color": _ctx.accentColor,
                "box-shadow": false
              }, null, 8, ["modelValue", "fa-icon", "color", "focus-color"])
            ])
          ]),
          (_ctx.showControls)
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                _createVNode(_component_v_checkbox, {
                  color: _ctx.accentColor,
                  modelValue: _ctx.toggleTrackSun,
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.toggleTrackSun) = $event)),
                  onKeyup: _cache[54] || (_cache[54] = _withKeys(($event: any) => (_ctx.toggleTrackSun = !_ctx.toggleTrackSun), ["enter"])),
                  label: "Track Sun",
                  "hide-details": ""
                }, null, 8, ["color", "modelValue"]),
                _createVNode(_component_v_checkbox, {
                  color: _ctx.accentColor,
                  modelValue: _ctx.showHorizon,
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.showHorizon) = $event)),
                  onKeyup: _cache[56] || (_cache[56] = _withKeys(($event: any) => (_ctx.showHorizon = !_ctx.showHorizon), ["enter"])),
                  label: "Horizon / Sky",
                  "hide-details": ""
                }, null, 8, ["color", "modelValue"]),
                _createVNode(_component_v_checkbox, {
                  color: _ctx.accentColor,
                  modelValue: _ctx.showAltAzGrid,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.showAltAzGrid) = $event)),
                  onKeyup: _cache[58] || (_cache[58] = _withKeys(($event: any) => (_ctx.showAltAzGrid = !_ctx.showAltAzGrid), ["enter"])),
                  label: "Sky Grid",
                  "hide-details": ""
                }, null, 8, ["color", "modelValue"]),
                _createVNode(_component_v_checkbox, {
                  color: _ctx.accentColor,
                  modelValue: _ctx.useRegularMoon,
                  "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.useRegularMoon) = $event)),
                  onKeyup: _cache[60] || (_cache[60] = _withKeys(($event: any) => (_ctx.useRegularMoon = !_ctx.useRegularMoon), ["enter"])),
                  label: "Visible Moon",
                  "hide-details": ""
                }, null, 8, ["color", "modelValue"])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_70, [
          _createVNode(_component_v_dialog, {
            modelValue: _ctx.showForecastSheet,
            "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.showForecastSheet) = $event)),
            "max-width": _ctx.xSmallSize ? '85%' : '45%',
            transition: "slide-y-transition",
            id: "weather-forecast-sheet",
            style: _normalizeStyle(_ctx.cssVars)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pb-8" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "dialog-close-button",
                        onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.showForecastSheet = false)),
                        onKeyup: _cache[62] || (_cache[62] = _withKeys(($event: any) => (_ctx.showForecastSheet = false), ["enter"])),
                        tabindex: "0"
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "xmark",
                          size: "xl",
                          color: _ctx.accentColor2
                        }, null, 8, ["color"])
                      ], 32),
                      _createVNode(_component_open_meteo_forecast, {
                        location: _ctx.locationDeg,
                        "location-str": _ctx.selectedLocationText,
                        time: (_ctx.eclipsePrediction !== null && _ctx.eclipseType != 'None') ? _ctx.eclipsePrediction.maxTime[0] : null
                      }, null, 8, ["location", "location-str", "time"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "max-width", "style"]),
          _createVNode(_component_v_dialog, {
            modelValue: _ctx.showEclipsePredictionSheet,
            "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.showEclipsePredictionSheet) = $event)),
            "max-width": _ctx.xSmallSize ? '95%' : 'fit-content',
            transition: "slide-y-transition",
            id: "eclipse-prediction-sheet",
            style: _normalizeStyle(_ctx.cssVars)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "dialog-close-button",
                        onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.showEclipsePredictionSheet = false)),
                        onKeyup: _cache[65] || (_cache[65] = _withKeys(($event: any) => (_ctx.showEclipsePredictionSheet = false), ["enter"])),
                        tabindex: "0"
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "xmark",
                          size: "xl",
                          color: _ctx.accentColor2
                        }, null, 8, ["color"])
                      ], 32),
                      _createVNode(_component_eclipse_timer, {
                        "show-timer": "",
                        prediction: _ctx.eclipsePrediction,
                        timezone: _ctx.selectedTimezone,
                        color: _ctx.accentColor,
                        location: _ctx.selectedLocationText
                      }, null, 8, ["prediction", "timezone", "color", "location"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "max-width", "style"]),
          (_ctx.withinForecastRange)
            ? (_openBlock(), _createBlock(_component_icon_button, {
                key: 0,
                modelValue: _ctx.showForecastSheet,
                "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.showForecastSheet) = $event)),
                "md-icon": "mdi-cloud-clock",
                "md-size": _ctx.showNewMobileUI ? '20' : '24',
                color: _ctx.accentColor,
                "focus-color": _ctx.accentColor,
                "tooltip-text": _ctx.showForecastSheet ? null : 'August 12 Weather Forecast',
                "tooltip-location": 'left',
                "show-tooltip": !_ctx.mobile,
                "box-shadow": false
              }, null, 8, ["modelValue", "md-size", "color", "focus-color", "tooltip-text", "show-tooltip"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_71, [
            (_ctx.onDayOfEclipse)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  id: "set-time-now-button",
                  variant: "outlined",
                  rounded: "xl",
                  disabled: _ctx.nowOutsideTimeRange,
                  color: _ctx.nowOutsideTimeRange ? 'gray' : '#eac402',
                  onClick: _cache[68] || (_cache[68] = () => {
            _ctx.selectedTime = Math.max(_ctx.minTime, Math.min(_ctx.maxTime, Date.now()));
            _ctx.playbackRate=1;
            _ctx.playing=true;
            })
                }, {
                  default: _withCtx(() => [...(_cache[174] || (_cache[174] = [
                    _createTextVNode(" Now ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "color"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("span", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createVNode(_component_icon_button, {
                    id: "play-pause-icon",
                    "fa-icon": !(_ctx.playing) ? 'play' : 'pause',
                    onActivate: _cache[69] || (_cache[69] = () => {
                  _ctx.playing = !(_ctx.playing);
                }),
                    color: _ctx.accentColor,
                    "focus-color": _ctx.accentColor,
                    "tooltip-text": "Play/Pause",
                    "tooltip-location": "top",
                    "tooltip-offset": "5px",
                    faSize: "lg",
                    "show-tooltip": !_ctx.mobile
                  }, null, 8, ["fa-icon", "color", "focus-color", "show-tooltip"]),
                  _createVNode(_component_icon_button, {
                    id: "backward-speed",
                    "fa-icon": 'angles-down',
                    onActivate: _cache[70] || (_cache[70] = () => {
                      _ctx.decreasePlaybackRate();
                      // playing = true;
                    }),
                    color: _ctx.accentColor,
                    "focus-color": _ctx.accentColor,
                    "tooltip-text": 'Slower',
                    "tooltip-location": "top",
                    "tooltip-offset": "5px",
                    faSize: "lg",
                    "show-tooltip": !_ctx.mobile
                  }, null, 8, ["color", "focus-color", "show-tooltip"]),
                  _createVNode(_component_icon_button, {
                    id: "forward-speed",
                    "fa-icon": 'angles-up',
                    onActivate: _cache[71] || (_cache[71] = () => {
                      _ctx.increasePlaybackRate();
                      // playing = true;
                    }),
                    color: _ctx.accentColor,
                    "focus-color": _ctx.accentColor,
                    "tooltip-text": 'Faster',
                    "tooltip-location": "top",
                    "tooltip-offset": "5px",
                    faSize: "lg",
                    "show-tooltip": !_ctx.mobile
                  }, null, 8, ["color", "focus-color", "show-tooltip"]),
                  (!_ctx.xSmallSize)
                    ? (_openBlock(), _createBlock(_component_icon_button, {
                        key: 0,
                        id: "reverse-speed",
                        "md-icon": _ctx.playbackRate < 0 ? 'mdi-step-forward-2' : 'mdi-step-backward-2',
                        onActivate: _cache[72] || (_cache[72] = () => {
                      _ctx.reversePlaybackRate();
                      // playing = true;
                    }),
                        color: _ctx.accentColor,
                        "focus-color": _ctx.accentColor,
                        "tooltip-text": _ctx.playbackRate < 0 ? 'Play time forwards' : 'Play time backwards',
                        "tooltip-location": "top",
                        "tooltip-offset": "5px",
                        mdSize: "22",
                        "show-tooltip": !_ctx.mobile
                      }, null, 8, ["md-icon", "color", "focus-color", "tooltip-text", "show-tooltip"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_icon_button, {
                    id: "reset",
                    "fa-icon": 'house',
                    onActivate: _cache[73] || (_cache[73] = () => {

                  _ctx.selectedTime = _ctx.initialSelectedTime;
                  _ctx.playbackRate = 500;
                  _ctx.playing = false;
                  _ctx.forceRate = false;
                  _ctx.location = _ctx.defaultLocation;
                  _ctx.selectedLocationText = _ctx.defaultLocationText;
                  _ctx.toggleTrackSun = true;
                  _ctx.sunPlace.set_zoomLevel(20);
                  _ctx.gotoTarget({
                    place: _ctx.sunPlace,
                    instant: true,
                    noZoom: false,
                    trackObject: true
                  });
                }),
                    color: _ctx.accentColor,
                    "focus-color": _ctx.accentColor,
                    "tooltip-text": "Reset",
                    "tooltip-location": "top",
                    "tooltip-offset": "5px",
                    faSize: "lg",
                    "show-tooltip": !_ctx.mobile
                  }, null, 8, ["color", "focus-color", "show-tooltip"]),
                  (!_ctx.xSmallSize)
                    ? (_openBlock(), _createBlock(_component_v_dialog, {
                        key: 1,
                        modelValue: _ctx.playbackVisible,
                        "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.playbackVisible) = $event)),
                        scrim: false,
                        location: "top end",
                        offset: "40",
                        "location-strategy": "connected",
                        persistent: "",
                        "no-click-animation": "",
                        "retain-focus": false
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_icon_button, _mergeProps({
                            id: "speed-control-icon",
                            onActivate: _cache[74] || (_cache[74] = () => {
                      _ctx.playbackVisible = !_ctx.playbackVisible;
                    }),
                            "fa-icon": _ctx.playbackVisible ? 'times' : 'gauge-high',
                            color: _ctx.accentColor,
                            "focus-color": _ctx.accentColor,
                            "tooltip-text": "Speed Controls",
                            "tooltip-location": "top",
                            "tooltip-offset": "5px",
                            faSize: "lg",
                            "show-tooltip": !_ctx.mobile
                          }, props), null, 16, ["fa-icon", "color", "focus-color", "show-tooltip"])
                        ]),
                        default: _withCtx(() => [
                          (_ctx.playbackVisible)
                            ? (_openBlock(), _createBlock(_component_playback_control, {
                                key: 0,
                                class: "desktop-playback-control",
                                "model-value": _ctx.playbackRate,
                                "onUpdate:modelValue": _cache[75] || (_cache[75] = (value) => {
                        _ctx.forceRate = false;
                        _ctx.playbackRate = value;
                      }),
                                "max-power": 3,
                                max: Math.log10(1000) + 1,
                                color: _ctx.accentColor,
                                inline: false
                              }, null, 8, ["model-value", "max", "color"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  (_ctx.xSmallSize)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                        _createVNode(_component_icon_button, {
                          id: "speed-control-icon",
                          onActivate: _cache[77] || (_cache[77] = () => {
                      _ctx.playbackVisible = !_ctx.playbackVisible;
                    }),
                          "fa-icon": _ctx.playbackVisible ? 'times' : 'gauge-high',
                          color: _ctx.accentColor,
                          "focus-color": _ctx.accentColor,
                          "tooltip-text": "Time Controls",
                          "tooltip-location": "top",
                          "tooltip-offset": "5px",
                          faSize: "lg",
                          "show-tooltip": !_ctx.mobile
                        }, null, 8, ["fa-icon", "color", "focus-color", "show-tooltip"]),
                        _withDirectives(_createVNode(_component_playback_control, {
                          class: "mobile-playback-control",
                          "model-value": _ctx.playbackRate,
                          "onUpdate:modelValue": _cache[78] || (_cache[78] = (value) => {
                        _ctx.forceRate = false;
                        _ctx.playbackRate = value;
                      }),
                          "max-power": 3,
                          max: Math.log10(1000) + 1,
                          color: _ctx.accentColor,
                          inline: true
                        }, null, 8, ["model-value", "max", "color"]), [
                          [_vShow, _ctx.playbackVisible]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createTextVNode(_toDisplayString(_ctx.niceRound(_ctx.playbackRate)) + "x Real Time", 1),
                  (!_ctx.playing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_78, " (paused)"))
                    : (_ctx.forceRate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_79, " (slowed for totality)"))
                      : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_v_slider, {
                  modelValue: _ctx.selectedTime,
                  "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.selectedTime) = $event)),
                  max: _ctx.maxTime,
                  min: _ctx.minTime,
                  color: _ctx.accentColor,
                  ripple: false,
                  "hide-details": "",
                  "track-size": "8px",
                  "thumb-size": "20px",
                  "thumb-label": "always",
                  step: _ctx.millisecondsPerInterval,
                  onMousedown: _cache[80] || (_cache[80] = () => {_ctx.playing = false;})
                }, {
                  "thumb-label": _withCtx((item) => [
                    _createTextVNode(_toDisplayString(_ctx.toTimeString(new Date(item.modelValue))), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "max", "min", "color", "step"])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_component_icon_button, {
                  "md-icon": "mdi-lock",
                  onActivate: _cache[81] || (_cache[81] = () => _ctx.showPrivacyDialog = true),
                  color: _ctx.accentColor,
                  "focus-color": _ctx.accentColor,
                  "tooltip-text": "Change privacy settings",
                  "tooltip-location": "bottom",
                  "tooltip-offset": "5px",
                  "show-tooltip": !_ctx.mobile,
                  mdSize: "1em"
                }, null, 8, ["color", "focus-color", "show-tooltip"])
              ])
            ])
          ]),
          (!_ctx.smallSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_dialog, {
          scrim: "false",
          modelValue: _ctx.showPrivacyDialog,
          "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.showPrivacyDialog) = $event)),
          "max-width": "400px",
          id: "privacy-popup-dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [...(_cache[175] || (_cache[175] = [
                    _createTextVNode(" To evaluate usage of this app, ", -1),
                    _createElementVNode("strong", null, "anonymized", -1),
                    _createTextVNode(" data may be collected, including locations viewed and map quiz responses. \"My Location\" data is NEVER collected. ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "pt-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "#BDBDBD",
                      href: "https://www.cfa.harvard.edu/privacy-statement",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, {
                      default: _withCtx(() => [...(_cache[176] || (_cache[176] = [
                        _createTextVNode(" Privacy Policy ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "#ff6666",
                      onClick: _cache[82] || (_cache[82] = () => {
              _ctx.responseOptOut = true;
              _ctx.showPrivacyDialog = false;
            })
                    }, {
                      default: _withCtx(() => [...(_cache[177] || (_cache[177] = [
                        _createTextVNode(" Opt out ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "green",
                      onClick: _cache[83] || (_cache[83] = () => {
              _ctx.responseOptOut = false;
              _ctx.showPrivacyDialog = false;
            })
                    }, {
                      default: _withCtx(() => [...(_cache[178] || (_cache[178] = [
                        _createTextVNode(" Allow ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_notifications, {
          group: "copy-url",
          position: "center top",
          classes: "url-notification"
        }),
        _createVNode(_component_notifications, {
          dangerouslySetInnerHtml: "",
          group: "geolocation-error",
          position: "center top"
        })
      ]),
      _createVNode(_component_v_expand_transition, null, {
        default: _withCtx(() => [
          (_ctx.showRating)
            ? (_openBlock(), _createBlock(_component_user_experience, {
                key: 0,
                question: _ctx.question,
                "icon-size": "3x",
                onDismiss: _cache[87] || (_cache[87] = (_rating, _comments) => {
        _ctx.showRating = false;
      }),
                onRating: _cache[88] || (_cache[88] = (rating) => {
        _ctx.currentRating = rating;
        _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
      }),
                onFinish: _cache[89] || (_cache[89] = (rating, comments) => {
        _ctx.currentRating = rating;
        _ctx.currentComments = comments;
        _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
        _ctx.showRating = false;
      })
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_83, [
                    _createVNode(_component_v_btn, {
                      class: "rating-opt-put",
                      color: "#BDBDBD",
                      size: "small",
                      variant: "text",
                      onClick: _cache[85] || (_cache[85] = () => {
              _ctx.showRating = false;
              _ctx.ratingOptOut = true;
            })
                    }, {
                      default: _withCtx(() => [...(_cache[179] || (_cache[179] = [
                        _createTextVNode(" Don't show again ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "privacy-button",
                      color: "#BDBDBD",
                      onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.showRatingPrivacyPolicy = true)),
                      size: "small",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, {
                      default: _withCtx(() => [...(_cache[180] || (_cache[180] = [
                        _createTextVNode(" What is this? ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["question"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_cds_privacy_policy, {
        modelValue: _ctx.showRatingPrivacyPolicy,
        "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.showRatingPrivacyPolicy) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["style", "inert"]))
}